var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState, useMemo } from 'react';
import { createPortal } from 'react-dom';
import styled, { css } from 'styled-components';
import { Manager, Reference, Popper } from 'react-popper';
import { colors, elevationCss, cssThemedValue } from '@creditornot/cb-ingredients';
import useDebounce from './useDebounce';
import Arrow from './Arrow';
var Root = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var ContentContainerRoot = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: auto;\n  box-sizing: border-box;\n  z-index: ", ";\n"], ["\n  width: auto;\n  box-sizing: border-box;\n  z-index: ", ";\n"])), function (_a) {
    var zIndex = _a.zIndex;
    return (zIndex === undefined ? 'auto' : zIndex);
});
var AnimatedContent = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  opacity: ", ";\n  transition: opacity ease-in 120ms;\n\n  ", "\n\n  @keyframes slideInTop {\n    0% {\n      transform: translateY(-12px);\n    }\n    100% {\n      transform: translateY(0px);\n    }\n  }\n  @keyframes slideOutTop {\n    0% {\n      transform: translateY(0px);\n    }\n    100% {\n      transform: translateY(-12px);\n    }\n  }\n\n  @keyframes slideInBottom {\n    0% {\n      transform: translateY(12px);\n    }\n    100% {\n      transform: translateY(0px);\n    }\n  }\n  @keyframes slideOutBottom {\n    0% {\n      transform: translateY(0px);\n    }\n    100% {\n      transform: translateY(12px);\n    }\n  }\n\n  @keyframes slideInLeft {\n    0% {\n      transform: translateX(-12px);\n    }\n    100% {\n      transform: translateX(0px);\n    }\n  }\n  @keyframes slideOutLeft {\n    0% {\n      transform: translateX(0px);\n    }\n    100% {\n      transform: translateX(-12px);\n    }\n  }\n\n  @keyframes slideInRight {\n    0% {\n      transform: translateX(12px);\n    }\n    100% {\n      transform: translateX(0px);\n    }\n  }\n  @keyframes slideOutRight {\n    0% {\n      transform: translateX(0px);\n    }\n    100% {\n      transform: translateX(12px);\n    }\n  }\n\n  animation: ", "\n    120ms;\n"], ["\n  opacity: ", ";\n  transition: opacity ease-in 120ms;\n\n  ", "\n\n  @keyframes slideInTop {\n    0% {\n      transform: translateY(-12px);\n    }\n    100% {\n      transform: translateY(0px);\n    }\n  }\n  @keyframes slideOutTop {\n    0% {\n      transform: translateY(0px);\n    }\n    100% {\n      transform: translateY(-12px);\n    }\n  }\n\n  @keyframes slideInBottom {\n    0% {\n      transform: translateY(12px);\n    }\n    100% {\n      transform: translateY(0px);\n    }\n  }\n  @keyframes slideOutBottom {\n    0% {\n      transform: translateY(0px);\n    }\n    100% {\n      transform: translateY(12px);\n    }\n  }\n\n  @keyframes slideInLeft {\n    0% {\n      transform: translateX(-12px);\n    }\n    100% {\n      transform: translateX(0px);\n    }\n  }\n  @keyframes slideOutLeft {\n    0% {\n      transform: translateX(0px);\n    }\n    100% {\n      transform: translateX(-12px);\n    }\n  }\n\n  @keyframes slideInRight {\n    0% {\n      transform: translateX(12px);\n    }\n    100% {\n      transform: translateX(0px);\n    }\n  }\n  @keyframes slideOutRight {\n    0% {\n      transform: translateX(0px);\n    }\n    100% {\n      transform: translateX(12px);\n    }\n  }\n\n  animation: ", "\n    120ms;\n"])), function (_a) {
    var show = _a.show;
    return (show ? '1' : '0');
}, function (_a) {
    var arrowPadding = _a.arrowPadding, placement = _a.placement;
    if (placement === null || placement === void 0 ? void 0 : placement.includes('top')) {
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        padding-bottom: ", ";\n      "], ["\n        padding-bottom: ", ";\n      "])), arrowPadding ? '10px' : '4px');
    }
    if (placement === null || placement === void 0 ? void 0 : placement.includes('right')) {
        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        padding-left: ", ";\n      "], ["\n        padding-left: ", ";\n      "])), arrowPadding ? '10px' : '4px');
    }
    if (placement === null || placement === void 0 ? void 0 : placement.includes('bottom')) {
        return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        padding-top: ", ";\n      "], ["\n        padding-top: ", ";\n      "])), arrowPadding ? '10px' : '4px');
    }
    if (placement === null || placement === void 0 ? void 0 : placement.includes('left')) {
        return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        padding-right: ", ";\n      "], ["\n        padding-right: ", ";\n      "])), arrowPadding ? '10px' : '4px');
    }
    return '';
}, function (_a) {
    var placement = _a.placement, show = _a.show;
    if (placement === null || placement === void 0 ? void 0 : placement.includes('top')) {
        return show ? 'slideInTop' : 'slideOutTop';
    }
    if (placement === null || placement === void 0 ? void 0 : placement.includes('bottom')) {
        return show ? 'slideInBottom' : 'slideOutBottom';
    }
    if (placement === null || placement === void 0 ? void 0 : placement.includes('left')) {
        return show ? 'slideInLeft' : 'slideOutLeft';
    }
    if (placement === null || placement === void 0 ? void 0 : placement.includes('right')) {
        return show ? 'slideInRight' : 'slideOutRight';
    }
    return '';
});
var ContentContainer = React.forwardRef(function (_a, ref) {
    var arrowPadding = _a.arrowPadding, children = _a.children, isOutOfView = _a.isOutOfView, placement = _a.placement, show = _a.show, hideWhenOutOfView = _a.hideWhenOutOfView, updateGeometry = _a.updateGeometry, rest = __rest(_a, ["arrowPadding", "children", "isOutOfView", "placement", "show", "hideWhenOutOfView", "updateGeometry"]);
    // If we just remove content from the DOM based on 'rendered' flag, popper.js won't be able to properly
    // calculate geometry for the initial showing - which results in visible jitter of the popover.
    // To overcome that and still have popover's content removed from the DOM while not shown,
    // we display it invisible initially, giving a chance to popper.js to calculate the geometry by calling updateGeometry(),
    // and after that - finally make the popover visible.
    var _b = __read(useState(show), 2), rendered = _b[0], setRendered = _b[1];
    var _c = __read(useState(show), 2), visible = _c[0], setVisible = _c[1];
    useEffect(function () {
        if (show) {
            setRendered(true);
            setVisible(false);
        }
    }, [show]);
    var onAnimationEnd = function () {
        if (!show) {
            setRendered(false);
        }
    };
    useEffect(function () {
        if (rendered) {
            updateGeometry().then(function () {
                setVisible(true);
            });
        }
    }, [rendered, updateGeometry]);
    return rendered ? (React.createElement(ContentContainerRoot, __assign({}, rest, { style: __assign(__assign({}, rest.style), { visibility: visible ? 'visible' : 'hidden' }), ref: ref }),
        React.createElement(AnimatedContent, { arrowPadding: arrowPadding, placement: placement, show: (!isOutOfView || !hideWhenOutOfView) && show, onAnimationEnd: onAnimationEnd }, children))) : null;
});
ContentContainer.displayName = 'PopoverContentContainer';
var arrowStyles = {
    up: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    top: 2px;\n  "], ["\n    top: 2px;\n  "]))),
    down: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    bottom: 2px;\n  "], ["\n    bottom: 2px;\n  "]))),
    left: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    left: 2px;\n  "], ["\n    left: 2px;\n  "]))),
    right: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    right: 2px;\n  "], ["\n    right: 2px;\n  "]))),
};
var StyledArrow = styled(Arrow)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  position: absolute;\n  ", "\n"], ["\n  position: absolute;\n  ", "\n"])), function (_a) {
    var direction = _a.direction;
    return arrowStyles[direction];
});
var getArrowDirection = function (placement) {
    if (placement === null || placement === void 0 ? void 0 : placement.includes('top')) {
        return 'down';
    }
    if (placement === null || placement === void 0 ? void 0 : placement.includes('bottom')) {
        return 'up';
    }
    if (placement === null || placement === void 0 ? void 0 : placement.includes('left')) {
        return 'right';
    }
    if (placement === null || placement === void 0 ? void 0 : placement.includes('right')) {
        return 'left';
    }
    return 'up';
};
var Content = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  min-height: 30px;\n  padding: ", ";\n  color: ", ";\n  border-radius: 8px;\n  box-sizing: border-box;\n\n  background-color: ", ";\n  ", "\n  box-shadow: 0 0 0 1px ", ", 0 4px 14px -2px ", ";\n"], ["\n  min-height: 30px;\n  padding: ", ";\n  color: ", ";\n  border-radius: 8px;\n  box-sizing: border-box;\n\n  background-color: ", ";\n  ", "\n  box-shadow: 0 0 0 1px ", ", 0 4px 14px -2px ", ";\n"])), function (_a) {
    var padded = _a.padded;
    return (padded ? '8px' : '0px');
}, cssThemedValue('textPrimary'), cssThemedValue('surfaceMain'), elevationCss(8), cssThemedValue({
    light: colors.pepper8,
    dark: colors.salt12,
}), colors.pepper12);
/* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint */
var isDefined = function (value) { return value !== undefined; };
var globalMountElement = null;
var createGlobalMountElement = function () {
    var mountElement = document && document.querySelector('.cb-popover-portal');
    if (mountElement) {
        return mountElement;
    }
    var elem = document.createElement('div');
    elem.className = 'cb-popover-portal';
    document.body.append(elem);
    return elem;
};
/* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint */
var usePrevious = function (value) {
    var ref = useRef();
    var prev = ref.current;
    ref.current = value;
    return prev;
};
var Popover = function (_a) {
    var _b = _a.boundariesElement, boundariesElement = _b === void 0 ? 'viewport' : _b, children = _a.children, className = _a.className, _c = _a.closeOnClickInside, closeOnClickInside = _c === void 0 ? false : _c, _d = _a.closeOnClickOutside, closeOnClickOutside = _d === void 0 ? true : _d, content = _a.content, contentZIndex = _a.contentZIndex, _e = _a.delayOnMouseEnter, delayOnMouseEnter = _e === void 0 ? 50 : _e, _f = _a.delayOnMouseLeave, delayOnMouseLeave = _f === void 0 ? 0 : _f, _g = _a.disableContentPadding, disableContentPadding = _g === void 0 ? false : _g, disabled = _a.disabled, fallbackPlacements = _a.fallbackPlacements, _h = _a.hideWhenOutOfView, hideWhenOutOfView = _h === void 0 ? true : _h, onClickInside = _a.onClickInside, onClickOutside = _a.onClickOutside, onCloseStart = _a.onCloseStart, onOpenStart = _a.onOpenStart, _j = _a.onRequestClose, onRequestClose = _j === void 0 ? function () { } : _j, _k = _a.placement, placement = _k === void 0 ? 'auto' : _k, portalElement = _a.portalElement, _l = _a.positionStrategy, positionStrategy = _l === void 0 ? 'fixed' : _l, _m = _a.renderArrow, renderArrow = _m === void 0 ? true : _m, show = _a.show, _o = _a.showOnClick, showOnClick = _o === void 0 ? true : _o, _p = _a.showOnHover, showOnHover = _p === void 0 ? true : _p, style = _a.style;
    if (!globalMountElement) {
        globalMountElement = createGlobalMountElement();
    }
    var mountElement = portalElement === undefined ? globalMountElement : portalElement;
    var mounted = useRef(false);
    useEffect(function () {
        mounted.current = true;
        return function () {
            mounted.current = false;
        };
    }, []);
    var _q = __read(useState({ open: false }), 2), _r = _q[0], open = _r.open, openSource = _r.source, setOpen = _q[1];
    var controlledMode = show !== undefined;
    var showPopover = (!disabled && show === true) || (!disabled && !controlledMode && open);
    var showPopoverPrev = usePrevious(showPopover);
    useEffect(function () {
        if (onCloseStart && !showPopover && showPopoverPrev === true) {
            onCloseStart();
        }
        else if (onOpenStart && showPopover && showPopoverPrev === false) {
            onOpenStart();
        }
    }, [onCloseStart, onOpenStart, showPopover, showPopoverPrev]);
    useEffect(function () {
        if (!controlledMode && disabled && open) {
            setOpen({ open: false });
        }
    }, [controlledMode, disabled, open]);
    var debouncedSetOpenWithEnterDelay = useDebounce(function (value) {
        if (mounted.current) {
            setOpen(value);
        }
    }, delayOnMouseEnter, {
        leading: false,
        trailing: true,
    }, [delayOnMouseEnter, setOpen]);
    var debouncedSetOpenWithLeaveDelay = useDebounce(function (value) {
        if (mounted.current) {
            setOpen(value);
        }
    }, delayOnMouseLeave, {
        leading: false,
        trailing: true,
    }, [delayOnMouseLeave, setOpen]);
    var handleMouseEnter = function () {
        if (!controlledMode && showOnHover) {
            debouncedSetOpenWithLeaveDelay && debouncedSetOpenWithLeaveDelay.cancel();
            debouncedSetOpenWithEnterDelay(function (state) {
                return !state.open ? { open: true, source: 'hover' } : state;
            });
        }
    };
    var handleMouseLeave = function () {
        if (!controlledMode && showOnHover) {
            debouncedSetOpenWithEnterDelay && debouncedSetOpenWithEnterDelay.cancel();
            debouncedSetOpenWithLeaveDelay(function (state) {
                return state.open && state.source === 'hover' ? { open: false } : state;
            });
        }
    };
    var handleClick = function (event) {
        /* Fixes an issue where the click was propagating up, effectively closing the
         * menu immediately after it had been opened */
        event.stopPropagation();
        if (controlledMode || !showOnClick) {
            return;
        }
        if (open && openSource !== 'hover') {
            setOpen({ open: false });
        }
        else {
            setOpen({ open: true, source: 'click' });
        }
    };
    var popperRef = useRef();
    var referenceRef = useRef();
    useEffect(function () {
        var listener = function (evt) {
            var event = evt;
            var target = event.target;
            if (!mounted.current) {
                return;
            }
            if (popperRef.current && popperRef.current.contains(target)) {
                if (onClickInside) {
                    onClickInside(event);
                }
            }
            else if (window.document.contains(target) &&
                referenceRef.current &&
                !referenceRef.current.contains(target)) {
                if (!controlledMode && open && closeOnClickOutside) {
                    setOpen({ open: false });
                }
                if (onClickOutside) {
                    onClickOutside(event);
                }
            }
        };
        if (showPopover) {
            window.document.addEventListener('click', listener, { capture: true });
        }
        return function () {
            if (showPopover) {
                window.document.removeEventListener('click', listener, { capture: true });
            }
        };
    }, [
        controlledMode,
        open,
        showPopover,
        setOpen,
        closeOnClickOutside,
        onClickInside,
        onClickOutside,
    ]);
    var renderProps = useMemo(function () { return ({
        close: function () {
            setOpen({ open: false });
            onRequestClose();
        },
        open: function () { return setOpen({ open: true, source: 'renderProp' }); },
    }); }, [onRequestClose, setOpen]);
    var modifiers = useMemo(function () {
        return [
            {
                name: 'computeStyles',
                enabled: true,
            },
            {
                name: 'preventOverflow',
                enabled: true,
                options: {
                    rootBounday: boundariesElement,
                },
            },
            {
                name: 'hide',
                enabled: true,
            },
            fallbackPlacements && {
                name: 'flip',
                options: {
                    fallbackPlacements: fallbackPlacements,
                },
            },
        ].filter(isDefined);
    }, [boundariesElement, fallbackPlacements]);
    var popper = (React.createElement(Popper, { placement: placement, innerRef: popperRef, modifiers: modifiers, strategy: positionStrategy }, function (_a) {
        var ref = _a.ref, newPlacement = _a.placement, update = _a.update, popperStyle = _a.style, arrowProps = _a.arrowProps, isReferenceHidden = _a.isReferenceHidden;
        return (React.createElement(ContentContainer, { ref: ref, style: popperStyle, "data-placement": newPlacement, onClick: function () {
                if (!controlledMode && closeOnClickInside) {
                    debouncedSetOpenWithLeaveDelay({ open: false });
                }
                update();
            }, arrowPadding: renderArrow, placement: newPlacement, show: showPopover, hideWhenOutOfView: hideWhenOutOfView, isOutOfView: !!isReferenceHidden, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, zIndex: contentZIndex, updateGeometry: update },
            React.createElement(Content, { padded: !disableContentPadding, placement: newPlacement }, typeof content === 'function' ? content(renderProps) : content),
            renderArrow && (React.createElement(StyledArrow, { direction: getArrowDirection(newPlacement), ref: arrowProps.ref, style: arrowProps.style }))));
    }));
    return (React.createElement(Manager, null,
        React.createElement(Reference, null, function (_a) {
            var ref = _a.ref;
            return (React.createElement(Root, { className: className, ref: function (elem) {
                    referenceRef.current = elem;
                    // related: https://github.com/microsoft/TypeScript/issues/30748
                    if (ref) {
                        ref(elem);
                    }
                }, style: style, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onClick: handleClick }, typeof children === 'function' ? children(renderProps) : children));
        }),
        mountElement ? createPortal(popper, mountElement) : popper));
};
export default Popover;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;
//# sourceMappingURL=Popover.js.map